import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTableModule } from '@angular/material/table';

import { RdsGetTableDimDatumCellIdsPipe } from './get-datum-cell-ids.pipe';
import { RdsGetDatumValuePipe } from './get-datum-value.pipe';
import { RdsGetHeaderCellValuePipe } from './get-header-cell-value.pipe';
import { RdsIncludeSubtotalsPipe } from './include-subtotals.pipe';
import { RdsNumberPipe } from './number.pipe';
import { RdsTabulationTableComponent } from './tabulation-table.component';

const PIPES = [RdsGetHeaderCellValuePipe, RdsIncludeSubtotalsPipe, RdsGetDatumValuePipe, RdsGetTableDimDatumCellIdsPipe, RdsNumberPipe];

@NgModule({
  imports: [CommonModule, MatTableModule],
  exports: [RdsTabulationTableComponent],
  declarations: [RdsTabulationTableComponent, PIPES],
  providers: [RdsGetDatumValuePipe],
})
export class RdsTabulationTableModule {}

export * from './models/index';
export * from './tabulation-table.component';
